var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('heading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }